import { FC } from 'react';

import { useTheme } from 'hooks/theme';

import { ScHaveAccountButton } from './styled';

interface HaveAccountButtonProps {
  descr: string;
  btnText: string;
  handleClick: () => void;
}

export const HaveAccountButton: FC<HaveAccountButtonProps> = ({
  descr,
  btnText,
  handleClick,
  ...props
}) => {
  const { images } = useTheme();

  return (
    <ScHaveAccountButton onClick={handleClick} {...props}>
      <span>{descr}</span>
      <span className="reg-link">
        {btnText} <images.arrowRightSmallIcon.component />
      </span>
    </ScHaveAccountButton>
  );
};
